<div class="user" [matMenuTriggerFor]="userMenu()" [class.pointer]="showMenu">
  @let thumbUrl = userData?.picture | thumbnail;
  <div class="profile-picture" [ngStyle]="userData?.picture ? {'background-image': 'url(' + thumbUrl + ')'} : {
    'background-image': 'url(' + (isAgent ? '/assets/images/kogu.background.png' : '') + ')',
  }">
    @if((!userData || !userData.picture) && !isAgent){
      {{ getInitials(userData?.name) }}
    }
  </div>
  <div class="user-status" [class.online]="userData.online" *ngIf="userData && userData.online">
    <span></span>
  </div>
</div>
@if(showMenu && userData && userData.id == currentUser.id){
  <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
    <ng-container>
      <button mat-menu-item (click)="setOnline(true)">
        <div class="user-status online static"></div>
        Conectado
      </button>
      <button mat-menu-item (click)="setOnline(false)">
        <div class="user-status offline static"></div>
        Deconectado
      </button>
  </ng-container>
  </mat-menu>
}
